import { render, staticRenderFns } from "./ui-status-bar-component.vue?vue&type=template&id=98bc67c4&scoped=true&"
import script from "./ui-status-bar-component.vue?vue&type=script&lang=ts&"
export * from "./ui-status-bar-component.vue?vue&type=script&lang=ts&"
import style0 from "./ui-status-bar-component.vue?vue&type=style&index=0&id=98bc67c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bc67c4",
  null
  
)

export default component.exports